import Marionette from 'backbone.marionette';
import watchedBillItemviewTmpl from '../templates/watchedbill_itemview.tpl';
export default Marionette.ItemView.extend({
  template: watchedBillItemviewTmpl,
  tagName: "div",
  className: "bill-list-item",
  templateHelpers: function () {
    return {
      formatStatusDate: function (status_date) {
        let formattedDate = new Date(status_date);
        return formattedDate.toLocaleDateString("en-US", {
          year: 'numeric',
          month: 'short',
          day: 'numeric'
        });
      }
    };
  },
  onShow: function () {
    //const prob = this.model.get("predictions") * 100;
    const id = this.model.get("bill_id");
    console.log("EMD model: ", this.model);
    console.log("EMD id: ", id);
    const obj = $("#" + id);
    // $(obj).addClass( function() {
    //   return prob <= 20 ? "less-likely"  :
    //          prob <  80 ? "likely" :
    //                       "more-likely";
    // });
  }
});